import * as THREE from 'three';
import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from 'three-mesh-bvh';

/**
 * three-mesh-bvh integration (task 3.4)
 *
 * Patches THREE prototypes once so raycasting (R3F pointer events included)
 * uses BVH acceleration whenever a geometry has computed its bounds tree.
 */
let prototypesPatched = false;

export function patchThreeForBVH(): void {
    if (prototypesPatched) return;
    prototypesPatched = true;

    (THREE.BufferGeometry.prototype as any).computeBoundsTree = computeBoundsTree;
    (THREE.BufferGeometry.prototype as any).disposeBoundsTree = disposeBoundsTree;
    (THREE.Mesh.prototype as any).raycast = acceleratedRaycast;
}

/**
 * Computes (once) the BVH bounds tree for the given geometry.
 * Used for heavy shared geometries (instanced primitives, merged statics).
 */
export function ensureGeometryBVH(geometry: THREE.BufferGeometry): void {
    patchThreeForBVH();
    const geometryWithBVH = geometry as THREE.BufferGeometry & { boundsTree?: unknown };
    if (!geometryWithBVH.boundsTree) {
        geometry.computeBoundsTree();
    }
}
